export default "__VITE_ASSET__a93f812f__"